import { render, staticRenderFns } from "./AuthorGalleryItemHorisontal.vue?vue&type=template&id=43eb7e1b&"
import script from "./AuthorGalleryItemHorisontal.vue?vue&type=script&lang=js&"
export * from "./AuthorGalleryItemHorisontal.vue?vue&type=script&lang=js&"
import style0 from "./AuthorGalleryItemHorisontal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports